import { Injectable } from '@angular/core';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { DemandDetails, DemandList, DwoDiagnoseCauseReasonTemplateList } from '../business-entities/dwo-diagnose-model';
import { DwoAppointemntSubCheckListViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { DWOCheckListRequestModel } from '../business-entities/dwo-sub-check-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'

@Injectable({
  providedIn: 'root'
})
export class DwoDiagnoseDataService {

  constructor(private dataService: DataService) { }
  getCheckList(param: DWOCheckListRequestModel): Promise<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>> {
    return this.dataService.Post<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>>(Urls.GetDwoCheckList, param).toPromise();
  }

  getDemandList(appointmentId: number): Promise<GenericResponse<Array<DemandList>>>{
    return this.dataService.Get<GenericResponse<Array<DemandList>>>(Urls.GetDiagnoseDemandList, appointmentId).toPromise();
  }
  getDemandDetails(appointmentGUID:string, appointmentDemandNo:number):Promise<GenericResponse<Array<DemandDetails>>>{
    return this.dataService.Get<GenericResponse<Array<DemandDetails>>>(Urls.GetDemandDetails, appointmentGUID,appointmentDemandNo).toPromise();
  }
  getDiagnoseCauseResonList(language:string,brand:string):Promise<GenericResponse<DwoDiagnoseCauseReasonTemplateList>>{
    return this.dataService.Get<GenericResponse<DwoDiagnoseCauseReasonTemplateList>>(Urls.GetDiagnoseCauseReason, language,brand).toPromise();
  }
  // getJobDiagnoseCauseList(appointmentGuid:string,appointmentDemandNo:any):Promise<GenericResponse<any>>{
  //   return this.dataService.Get<GenericResponse<any>>(Urls.GetJobDiagnoseCauseList, appointmentGuid, appointmentDemandNo).toPromise();
  // }
  // getDiagnoseCauseList(languageCode:any):Promise<GenericResponse<any>>{
  //   return this.dataService.Get<GenericResponse<any>>(Urls.GetDiagnoseCauseList, languageCode).toPromise();
  // }
  SaveJobDiagnoseCauseReason(model:any):Promise<GenericResponse<any>>{
    return this.dataService.Post<GenericResponse<any>>(Urls.SaveJobDiagnoseCauseReason, model).toPromise();
  }
  SaveCheckList(model:any):Promise<GenericResponse<any>>{
    return this.dataService.Post<GenericResponse<any>>(Urls.SaveCheckList, model).toPromise();
  }
  getSstCheckList(appointmentId: any)
  {
    return this.dataService.Get<any>(Urls.GetInspectionsOperationsDetails, appointmentId).toPromise();
  }
}
